import { differenceInCalendarDays } from "date-fns";

export enum SortOrder {
  Ascending = 'ascend',
  Descending = 'descend'
}

export type SortDirectionType = 'asc' | 'desc' | null;

export const toggleSortOrder = ( value: SortDirectionType ): SortDirectionType => {
  switch( value ) {
    case null:
      return 'asc';
    case 'asc':
      return 'desc';
    case 'desc':
      return null;
    default:
      throw new Error( 'sort order not valid value' );
  }
}

export const sortString = ( sortDirection: SortDirectionType, a: string, b: string ): number => {
  if( sortDirection === 'asc' ) {
    return a.localeCompare( b );
  }
  if( sortDirection === 'desc' ) {
    return b.localeCompare( a );
  }
  return 0;
}

export const sortNumbers = ( sortDirection: SortDirectionType, a: number, b: number ): number => {
  if( sortDirection === 'asc' ) {
    return a - b;
  }
  if( sortDirection === 'desc' ) {
    return b - a;
  }
  return 0;
}

export function ascendingSorting( firstCompareValue, secondCompareValue ): any {
  return firstCompareValue > secondCompareValue ? 1 : -1;
}

export function descendingSorting( firstCompareValue, secondCompareValue ): any {
  return firstCompareValue < secondCompareValue ? 1 : -1;
}

export function sortingCase( status, firstCompareValue, secondCompareValue, columnKey ): any {
  const hasIndexOfRaw = firstCompareValue.index || firstCompareValue.index === 0 ? true : false;

  const firstValue =
    typeof firstCompareValue[columnKey] === 'object' ?
      firstCompareValue[columnKey].name.toLowerCase() :
      firstCompareValue[columnKey]?.toLowerCase();

  const secondValue =
    typeof secondCompareValue[columnKey] === 'object' ?
      secondCompareValue[columnKey].name.toLowerCase() :
      secondCompareValue[columnKey]?.toLowerCase();

  switch( status ) {
    case SortOrder.Ascending:
      return ascendingSorting( firstValue, secondValue );
      return 0;
      break;
    case SortOrder.Descending:
      return descendingSorting( firstValue, secondValue );
      return 0;
      break;
    default:
      if( hasIndexOfRaw ) {
        if( firstCompareValue.index > secondCompareValue.index ) {
          return 1;
        }
        if( firstCompareValue.index < secondCompareValue.index ) {
          return -1;
        }
      }
      return 0;
  }
}

export const disableDates = ( current: Date, months?: number, leftDate = new Date() ): boolean => {
  const lastDayOfTheMonth = new Date( new Date().getFullYear()+1, new Date().getMonth(), 0 ).getDate();

  const endDate = new Date();
  endDate.setDate( lastDayOfTheMonth );
  endDate.setMonth( months ? endDate.getMonth() - months : endDate.getMonth() );
  endDate.setFullYear( endDate.getFullYear() + 3 );  // Three years after start date

  return differenceInCalendarDays( current, leftDate ) <= 0 || differenceInCalendarDays( current, endDate ) > 0;
};

function getFirstAndLast(num: number): number {
  const str = num.toString();
  const first = parseInt(str[0], 10);
  const last = parseInt(str[str.length - 1], 10);

  return  parseInt(first +""+ last);
}

export const getRoundingPriceValue=(input: number): number =>{
  const lastTwoDigits = getFirstAndLast(input);
  if (lastTwoDigits >= 0 && lastTwoDigits <= 9) return 95;
  if (lastTwoDigits >= 10 && lastTwoDigits <= 33) return 25;
  if (lastTwoDigits >= 34 && lastTwoDigits <= 63) return 50;
  if (lastTwoDigits >= 64 && lastTwoDigits <= 83) return 75;
  if (lastTwoDigits >= 84 && lastTwoDigits <= 99) return 95;

  throw new Error("Input out of range (expected 0–99).");
}

export function getClosestSingleSuppOption(singleSuppValue: number) {
  const value = singleSuppValue * 100;  // convert 1.77 → 177

  if (value < 105)   return { value: 1.00, label: "100%" };
  if (value < 117.5) return { value: 1.10, label: "110%" };
  if (value < 132.5) return { value: 1.25, label: "125%" };
  if (value < 145)   return { value: 1.40, label: "140%" };
  if (value < 162.5) return { value: 1.50, label: "150%" };
  if (value < 177.5) return { value: 1.75, label: "175%" };
  if (value < 185)   return { value: 1.80, label: "180%" };
  if (value < 195)   return { value: 1.90, label: "190%" };

  return { value: 2.00, label: "200%" };
}

export function getLastDayOfMonth(dateString) {
  // Parse DD/MM/YYYY manually
  const [, month, year] = dateString.split("/").map(Number);

  // JS months are 0-based → month (1–12) becomes (0–11)
  const lastDay = new Date(year, month, 0);

  return lastDay;  // ← returns Date object
}
